import { Controller, FieldValues } from 'react-hook-form';

import useTranslate from '@/hooks/useTranslate';
import { SharedInputProps } from '@/pages/members/pages/Onboarding/components/shared/types';
import { COMPONENTS_SHARED_PATH_TRANSLATION_KEY } from '@/pages/members/pages/Onboarding/constants';
import FieldError from '@/ui/members/components/form/FieldError';
import InputField from '@/ui/members/components/form/Input/Input';

const LastNameInput = <T extends FieldValues>({
  control,
  fieldError,
  name
}: SharedInputProps<T>) => {
  const { t } = useTranslate(`${COMPONENTS_SHARED_PATH_TRANSLATION_KEY}.LastNameInput`);

  return (
    <>
      <Controller
        name={name}
        control={control}
        rules={{
          required: t('lastNameIsRequired')
        }}
        render={({ field }) => (
          <InputField
            autoFocus
            id="last-name"
            label={t('lastNameLabel')}
            onChange={field.onChange}
            placeholder={t('lastNamePlaceholder')}
            type="text"
            value={field.value}
          />
        )}
      />

      <FieldError error={fieldError} />
    </>
  );
};

export default LastNameInput;
